module.exports = __webpack_public_path__ + "media/images/mobile/home/banner2-7cb6f1e2cd313e4fc8862686acfd087c.jpg";